'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.emptyFunc = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _radium = require('radium');

var _radium2 = _interopRequireDefault(_radium);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

var _WMCheckbox = require('../WMCheckbox');

var _WMCheckbox2 = _interopRequireDefault(_WMCheckbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
	hideDisabledCheckboxes: _propTypes2.default.bool,
	children: _propTypes2.default.node.isRequired,
	style: _propTypes2.default.object,
	striped: _propTypes2.default.bool,
	selectable: _propTypes2.default.bool,
	selected: _propTypes2.default.bool,
	onSelectRow: _propTypes2.default.func
};

var WMTableRow = function WMTableRow(_ref) {
	var hideDisabledCheckboxes = _ref.hideDisabledCheckboxes,
	    children = _ref.children,
	    style = _ref.style,
	    striped = _ref.striped,
	    selectable = _ref.selectable,
	    selected = _ref.selected,
	    onSelectRow = _ref.onSelectRow;
	return _react2.default.createElement(
		'div',
		{
			'data-component-identifier': 'wm-table-row',
			style: Object.assign({}, _styles2.default.row, _styles2.default.row.striped(striped), _styles2.default.row.selected(selected), style)
		},
		(selectable || !hideDisabledCheckboxes) && _react2.default.createElement(
			'div',
			{
				'data-component-identifier': 'wm-table-row__checkbox-container',
				style: _styles2.default.checkbox
			},
			_react2.default.createElement(_WMCheckbox2.default, {
				disabled: !selectable,
				checked: selected,
				onCheck: function onCheck(event, isInputChecked) {
					return onSelectRow(isInputChecked);
				}
			})
		),
		children
	);
};

var emptyFunc = exports.emptyFunc = function emptyFunc() {};

WMTableRow.defaultProps = { onSelectRow: emptyFunc };

exports.default = (0, _radium2.default)(WMTableRow);


// WEBPACK FOOTER //
// ./~/@workmarket/front-end-components/dist/WMTableRow/index.js